var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "notice" },
    [
      _c("el-scrollbar", { staticStyle: { height: "100vh" } }, [
        _c("div", {
          staticClass: "cont",
          domProps: { innerHTML: _vm._s(_vm.noticeData) },
        }),
        _c(
          "div",
          { staticClass: "checkedConfirm" },
          [
            _c(
              "el-checkbox",
              {
                model: {
                  value: _vm.checkedConfirm,
                  callback: function ($$v) {
                    _vm.checkedConfirm = $$v
                  },
                  expression: "checkedConfirm",
                },
              },
              [_vm._v("确认告知书")]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "btnConfirm" },
          [
            _c(
              "el-button",
              {
                attrs: { type: "success", disabled: !_vm.checkedConfirm },
                on: { click: _vm.btnConfirm },
              },
              [_vm._v("确认告知书")]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }